import { useState } from "react";
import { useNavigate, useLocation, Navigate, Link } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import AuthShell, { Field, SubmitButton, ErrorNote } from "@/pages/Login";

export default function VerifyTwoFactorPage() {
  const { verify2fa } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const tempToken = location.state?.tempToken;
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!tempToken) return <Navigate to="/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await verify2fa(tempToken, code);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Two-factor code"
      subtitle="Enter the 6-digit code from your authenticator app."
      footer={
        <Link to="/login" className="hover:text-foreground" data-testid="verify-back-to-login">
          Back to sign in
        </Link>
      }
    >
      <form onSubmit={submit} data-testid="verify-2fa-form">
        <ErrorNote message={error} />
        <Field
          label="Authentication code"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          required
          placeholder="123456"
          data-testid="verify-2fa-code"
        />
        <SubmitButton loading={loading} data-testid="verify-2fa-submit">
          Verify
        </SubmitButton>
      </form>
    </AuthShell>
  );
}
